import { render, staticRenderFns } from "./CountryDelete.vue?vue&type=template&id=0fbf4e7f&scoped=true&"
import script from "./CountryDelete.vue?vue&type=script&lang=js&"
export * from "./CountryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf4e7f",
  null
  
)

export default component.exports